/* Function for letting price stay on top when user is scrolling down */

window.addEventListener("DOMContentLoaded", () => {

    var elementSelectIdentifier = '.product__info-wrapper .price.price--large .price__container';

    // var cssTopOffset = -220;
    var fixStartAtScrollPos = 250;

    const updateAbsolutePricePosition = function() {
        var el = document.querySelector(elementSelectIdentifier);
        
        // console.log('window.scrollY: ' + window.scrollY);

        let posParentElement = document.querySelector('.product__info-container.product__column-sticky');
        if (!posParentElement) {
            return;
        }

        let newTopPos = - posParentElement.getBoundingClientRect().top;

        // console.log('newTopPos: ' + newTopPos);

        let newTopPosStr = newTopPos + 'px';

        if (window.scrollY > fixStartAtScrollPos) {
            el.style.position = 'fixed';
            el.classList.add('price-fixed-on-top');
            el.style.top = newTopPosStr;
        } else {
            el.style.position = 'initial';
            el.classList.remove('price-fixed-on-top');
        }    
    };

    updateAbsolutePricePosition();

    window.addEventListener('scroll', function () {
        updateAbsolutePricePosition();
    });

});
